export const numberComparator = (a: number, b: number, tolerance = 0.0000000000001): boolean => {
    return Math.abs(a - b) <= tolerance;
};

export const isInRange = (number: number, from: number, to: number) => {
    return number >= Math.min(from, to) && number <= Math.max(from, to);
};
